export function Selection({ children, label }: React.PropsWithChildren<{ label: string }>) {
  return (
    <div className="flex items-center justify-between">
      <p className="font-bold">{label}</p>
      {children}
    </div>
  )
}
